@if(!isModalContext) {
    <app-button-close appNavigateBack/>
}

<app-listing [(paginationSize)]="paginationSize"
             [displayCount]="false"
             [key]="listingId"
             [ngClass]="{'modal-context': isModalContext }"
             [paginationRowsByPageList]="paginationRowsByPageList"
             [exportHeaders]="columnsForCSVExport"
             appListingConfirmRGPDDialog
             searchBarPlaceholder="Nom, prénom, matricule, mail">

    <!-- titre du listing -->
    @if(!isModalContext) {
        <ng-template appListingTitle>
            Liste des bénéficiaires
        </ng-template>
    }

    <ng-template appListingAfterSearchbarButtons>
        @if(!isModalContext) {
            <kal-button (click)="navigateToBeneficiaryEdit()"
                        [disabled]="dataSource.loading.value"
                        class="gup-C-searchBar__filterBtn kal-theme--large">
                <kal-icon>add</kal-icon>
                <span>Ajouter un bénéficiaire</span>
            </kal-button>
        }
    </ng-template>

    <!-- dessus du tableau -->
    <ng-template appListingHeader>
        @if(!filtersComponent.displayFilters) {
            <div class="listing-header">
                @if(CurrentVue) {

                    <aside>

                        <div>
                            <span>Nombre de bénéficiaires total : </span>
                            <span>{{ NombreBenefTot }}</span>
                        </div>

                        <div>
                            <span>Nombre de bénéficiaires filtrés : </span>
                            <span>{{ NombreBenefTotFiltre }}</span>
                        </div>

                        <div>

                            <span>Vue : </span>
                            <span [kalMenuTriggerFor]="selectVueMenu">
                            <span>{{ CurrentVue.Libelle}}</span>
                            <kal-icon>keyboard_arrow_down</kal-icon>
                        </span>
                            <kal-menu #selectVueMenu>
                                @for(view of ListeVues; track view.Id) {
                                    <kal-option (selectionChange)="fetchNewVue(view)"
                                                [disabled]="view.Id === CurrentVue.Id">
                                        {{ view.Libelle }}
                                    </kal-option>
                                }
                            </kal-menu>

                        </div>

                        <div>

                            <span>Droits : </span>
                            <span [kalMenuTriggerFor]="selectRightMenu">
                        <span>{{ getBenefDroitLabel() }}</span>
                        <kal-icon>keyboard_arrow_down</kal-icon>
                    </span>
                            <kal-menu #selectRightMenu>
                                @for(status of [true, false, null]; track $index) {
                                    <kal-option
                                        (selectionChange)="changeBenefAvecDroitActif(status)"
                                        [disabled]="BenefAvecDroitActif === status">
                                        {{ getBenefDroitLabel(status) }}
                                    </kal-option>
                                }
                            </kal-menu>

                        </div>

                    </aside>

                }
            </div>
        }
    </ng-template>

    <app-shared-beneficiary-list-filters #filtersComponent/>

    <kal-table
        [kalLoading]="loading"
        #kalTableComponent
        [columns]="columns"
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [selection]="selection"
        [virtualItemSize]="26"
        [actionable]="canEditBeneficary"
        virtual>

        <tr *kalHeaderRowDef kal-header-row></tr>

        <!-- kal-defaut column -->
        <ng-container [kalColumn]="kalTableComponent.defaultColumnName">
            <ng-container *kalBodyCell="let row; let code = code">
                @let column = getColumnByCode(code);
                @if(column) {
                    <td [class]="'kal-column-'+code" [style.width.px]="column.LargeurColonne">
                        @switch(column.TypeValeur) {
                            <!--dans ce cas on va rechercher dans les valeurs de la définitions de la colonne-->
                            @case(TypesValeursEnum.ListeValeurs) {
                                {{ findValue(column.ListeValeurs, row[code])}}
                            }
                            @case(TypesValeursEnum.Bool) {
                                {{ toYesNoEmpty(row[code]) }}
                            }
                            @case(TypesValeursEnum.Date) {
                                @let time = toDate(row[code]);
                                @if(time) {
                                    <time [dateTime]="row[code]">{{ time | date }}</time>
                                }
                            }
                            @default {
                                {{ row[code] }}
                            }
                        }
                    </td>
                }
            </ng-container>

            <ng-container [kalColumn]="kalTableComponent.actionColumnName">
                <td *kalBodyCell="let row">

                    <kal-button [kalMenuTriggerFor]="actionsMenu"
                                (click)="$event.stopPropagation()"
                                kalTheme="tertiary">
                        <kal-icon>more_horiz</kal-icon>
                    </kal-button>

                    <kal-menu #actionsMenu>
                        <kal-option (selectionChange)="navigateToBeneficiaryEdit(row['ID'])">
                            Modifier
                        </kal-option>
                    </kal-menu>

                </td>
            </ng-container>

            <th *kalHeaderCell="let code = code" [kalTableHeader]="code"
                [style.width.px]="getColumnByCode(code).LargeurColonne">
                {{ getColumnByCode(code).NomColonne }}
            </th>

        </ng-container>

    </kal-table>


</app-listing>

